import React from 'react'
import { branch, renderComponent } from 'recompose'

import CircularProgress from '@material-ui/core/CircularProgress'

const Progress = () => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <CircularProgress color="secondary" />
  </div>
)
export default branch(
  ({ data: { loading } }) => loading,
  renderComponent(Progress)
)
